import flatpickr from "flatpickr";
const defaultDateFormat = "d/m/Y";
// Options parser: only common options 
// manually convert attribute options to flatpickr option
const returnStringOption = (name, value) => {
    return { [name]: value };
};
const returnDateOption = (name, value) => {
    let newValue = "";
    if (value.length > 0) {
        newValue = (value === "today" ? value : new Date(value));
    }
    return { [name]: newValue };
};
const returnBooleanOption = (name, value) => {
    return { [name]: value.toLowerCase() === "true" };
};
const flatpickrOptions = {
    altformat: (value) => returnStringOption("altFormat", value),
    altinput: (value) => returnBooleanOption("altInput", value),
    altinputclass: (value) => returnStringOption("altInputClass", value),
    allowinput: (value) => returnBooleanOption("allowInput", value),
    dateformat: (value) => returnStringOption("dateformat", value),
    defaultdate: (value) => returnDateOption("defaultDate", value),
    maxdate: (value) => returnStringOption("maxDate", value),
    mindate: (value) => returnStringOption("minDate", value),
};
export default class FlatpickrControl {
    constructor(element, changeCallback = undefined, endDateChangeCallback = undefined) {
        this._isDatePicker = () => {
            return this.element.hasAttribute("data-flatpickr");
        };
        this._isTimePicker = () => {
            return this.element.hasAttribute("data-flatpickr-time");
        };
        this._isDateRangePicker = () => {
            return this.element.hasAttribute("data-flatpickr-range");
        };
        this.init = (overrideOptions = {}) => {
            let dateFormat = defaultDateFormat;
            // get inline options
            const inlineOptions = parseAllPickrOptions(this.element);
            // date picker
            let options = {
                allowInput: true, altInput: true, altFormat: dateFormat
            };
            // time picker
            if (this._isTimePicker()) {
                options = {
                    allowInput: true, altInput: true, altFormat: dateFormat, enableTime: true, noCalendar: true, time_24hr: true
                };
            }
            // if element is not an input
            // use wrapper behaviour
            const tagName = this.element.tagName.toLowerCase();
            if (tagName !== 'input') {
                options['wrap'] = true;
            }
            // date range picker
            // init enddate
            if (this._isDateRangePicker() && this.element.getAttribute("data-flatpickr-range").length > 0) {
                this.endDateInstance = new FlatpickrControl(document.querySelector(this.element.getAttribute("data-flatpickr-range")), this.endDateChangeCallback);
                this.endDateInstance.init();
            }
            // init
            this.currentDatePickr = flatpickr(this.element, Object.assign(Object.assign(Object.assign(Object.assign({}, options), inlineOptions), overrideOptions), { onChange: (date, dateString) => {
                    if (this.changeCallback) {
                        this.changeCallback(date, dateString);
                    }
                    // trigger date change event
                    this.element.dispatchEvent(new CustomEvent("datechange", {
                        detail: {
                            date,
                            dateString
                        }
                    }));
                    // on change: set min date to end date
                    if (this.endDateInstance) {
                        this.endDateInstance.currentDatePickr.set("minDate", dateString);
                    }
                } }));
            // set min date to end date if default start date set
            if (this.endDateInstance && this.currentDatePickr.selectedDates[0]) {
                const dateString = flatpickr.formatDate(this.currentDatePickr.selectedDates[0], this.currentDatePickr.config.altFormat);
                this.endDateInstance.currentDatePickr.set("minDate", dateString);
                console.log(this.currentDatePickr.config);
                console.log(this.endDateInstance.currentDatePickr.config);
            }
            return this.currentDatePickr;
        };
        this.element = element;
        this.changeCallback = changeCallback;
        this.endDateChangeCallback = endDateChangeCallback;
    }
}
function parseAllPickrOptions(element) {
    let options = {};
    [].slice.call(element.attributes).forEach(attr => {
        if (attr.name.startsWith("data-flatpickr-")) {
            const name = attr.name.substring("data-flatpickr-".length);
            const value = attr.value;
            options = Object.assign(Object.assign({}, options), convertToFlatPickrOption(name, value));
        }
    });
    return options;
}
function convertToFlatPickrOption(name, value) {
    if (flatpickrOptions[name]) {
        return flatpickrOptions[name](value);
    }
    else {
        return {};
    }
}
